import { render } from "./DatabaseManager.vue?vue&type=template&id=2de9834b&scoped=true"
import script from "./DatabaseManager.vue?vue&type=script&lang=js"
export * from "./DatabaseManager.vue?vue&type=script&lang=js"

import "./DatabaseManager.vue?vue&type=style&index=0&id=2de9834b&scoped=true&lang=scss"

import exportComponent from "/tmp/f3315f41-3418-4066-838e-b0c15008937b/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2de9834b"]])

export default __exports__